export default __webpack_public_path__ + "static/media/marimba_long.0b47bb05.mp3";